import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import useAuthStore from '../store/authStore';
import toast from 'react-hot-toast';

export default function RegisterPatient() {
  const [form, setForm] = useState({ name:'', phone:'', password:'', email:'', city:'', gender:'male' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/register/patient', form);
      login(res.data.user, res.data.token);
      toast.success('Inscription réussie !');
      navigate('/patient/dashboard');
    } catch (err) {
      const errors = err.response?.data?.errors;
      if (errors) Object.values(errors).forEach(e => toast.error(e[0]));
      else toast.error('Erreur inscription');
    } finally {
      setLoading(false);
    }
  };

  const cities = ['Lomé','Kpalimé','Atakpamé','Sokodé','Kara','Dapaong','Tsévié','Aného'];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="text-4xl mb-2">🏥</div>
          <h1 className="text-2xl font-bold text-green-700">SantéTogo</h1>
        </div>
        <div className="card">
          <h2 className="text-xl font-bold mb-6">Inscription Patient</h2>
          <form onSubmit={handleSubmit} className="space-y-3">
            <input className="input-field" placeholder="Nom complet *" value={form.name}
              onChange={e => setForm({...form, name: e.target.value})} required />
            <input className="input-field" type="tel" placeholder="Téléphone * (ex: 90123456)" value={form.phone}
              onChange={e => setForm({...form, phone: e.target.value})} required />
            <input className="input-field" type="password" placeholder="Mot de passe *" value={form.password}
              onChange={e => setForm({...form, password: e.target.value})} required />
            <input className="input-field" type="email" placeholder="Email (optionnel)" value={form.email}
              onChange={e => setForm({...form, email: e.target.value})} />
            <select className="input-field" value={form.city} onChange={e => setForm({...form, city: e.target.value})}>
              <option value="">Sélectionner une ville</option>
              {cities.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <select className="input-field" value={form.gender} onChange={e => setForm({...form, gender: e.target.value})}>
              <option value="male">Homme</option>
              <option value="female">Femme</option>
            </select>
            <button type="submit" disabled={loading} className="btn-primary w-full py-3">
              {loading ? 'Inscription...' : "S'inscrire"}
            </button>
          </form>
          <p className="mt-4 text-center text-sm text-gray-600">
            Déjà un compte ? <Link to="/login" className="text-green-600 font-semibold">Se connecter</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
